import { AdminFeatureFlag } from "../types/AdminFeatureFlag";

export const FEATURE_FLAG_DEFAULTS: Record<AdminFeatureFlag, boolean> = {
  ONBOARDING_DEMOS: process.env.NEXT_PUBLIC_ONBOARDING_DEMOS === "true",
  MATCHING_PROVIDERS: process.env.NEXT_PUBLIC_MATCHING_PROVIDERS === "true",
};
